import { defineMessages } from 'react-intl';

export default defineMessages({
    loggingOut: {
        id: 'app.logoutPage.loggingOut',
        defaultMessage: 'You are being logged out...'
    },
    error: {
        id: 'app.logoutPage.error',
        defaultMessage: 'Something went wrong.'
    }
});
